import {
  DsTour,
  HorizontalFooter,
  HorizontalHeader,
  HorizontalLayout,
  LayoutWrapper,
  VerticalFooter,
  VerticalLayout,
  VerticalNavbar,
  VerticalNavigation,
  getMode,
  getSystemMode,
} from '@ice-web-app/designSystem';
import { useGlobalStore } from '@ice-web-app/shared-store';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';

export interface BasePortalProps {
  microSystem?: boolean;
  sidebar?: boolean;
  showUserRole?: boolean;
  miniSidebar?: boolean;
  navbar?: boolean;
  sidebarHeader?: boolean;
}

export const BasePortal: FC<BasePortalProps> = ({
  microSystem,
  sidebar,
  showUserRole,
  miniSidebar = true,
  navbar = true,
  sidebarHeader = true,
}) => {
  const mode = getMode();
  const systemMode = getSystemMode();
  const { showHeader } = useGlobalStore();

  return (
    <>
      <LayoutWrapper
        systemMode={systemMode}
        verticalLayout={
          <VerticalLayout
            navigation={
              sidebar ? (
                <VerticalNavigation
                  mode={mode}
                  systemMode={systemMode}
                  miniSidebar={miniSidebar}
                  sidebarHeader={sidebarHeader}
                />
              ) : null
            }
            navbar={navbar && showHeader ? <VerticalNavbar sidebar={sidebar} /> : null}
            footer={<VerticalFooter />}
          >
            <Outlet />
          </VerticalLayout>
        }
        horizontalLayout={
          <HorizontalLayout header={<HorizontalHeader />} footer={<HorizontalFooter />}>
            <h1>Materio page!</h1>
          </HorizontalLayout>
        }
      />

      <DsTour />
    </>
  );
};
